import React, { useState, useEffect, useRef, useCallback } from "react";
import ReviewPopup from "./review-popup";
import DocumentPreview from "../Create-Investment/documentpreview";
import ActivityLog from "../../Components/ActivityLog/activity-log";
import StatusButton from "../../Components/Onbaording/status-button";
import SectionStatusGrid from "../../Components/Onbaording/status-section";
import FileUploadDisplay from "../../Components/Onbaording/file-display";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";
import { useDispatch, useSelector } from "react-redux";
import { debounce, reject } from "lodash";

const ReviewKycJointAccount = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const buttonRefs = useRef({});
  const dropdownRef = useRef();
  const { customerId } = useParams();
  const navigate = useNavigate();
  const updateFieldStatus = useSelector(
    (state) => state.deletedAccount.updateFieldStatus,
  );
  const location = useLocation();
  const { showToast } = useToast();
  const [showPopup, setShowPopup] = useState(false);
  const [taxResidentCountry, setTaxResidentCountry] = useState(null);
  const [nonResCountryText, setNonResCountryText] = useState(null);
  const [photoIdSecondText, setphotoIdSecondText] = useState(null);
  const [photoIdSecond, setphotoIdSecond] = useState(null);
  const [webLink, setWebLink] = useState("");
  const [isActivityLogOpen, setIsActivityLogOpen] = useState(false);
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [personalDataId, setPersonalDataId] = useState(1);
  const [personalDataIdText, setPersonalDataIdText] = useState("");
  const [fileCV, setFileCV] = useState(null);
  const [fullName, setFullName] = useState(null);
  const [investmentCurrency, setInvestmentCurrency] = useState(null);
  const [jointAccountName, setJointAccountName] = useState("");
  const [advisor, setAdvisor] = useState(null);
  const [nonphotoIdText, setNonPhotoIdText] = useState("");
  const [nonphotoId, setNonPhotoId] = useState(null);
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState(null);
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [expiryDateSecond, setExpiryDateSecond] = useState(null);
  const [bankdata, setBankdata] = useState([]);
  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [jointAccountID, setJointAccountID] = useState(null);
  const [accountPurpose, setAccountPurpose] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [documentNumber, setDocumentNumber] = useState(null);

  const [applicantCountry, setApplicantCountry] = useState(null);
  const [socialSecurityNumber, setSocialSecurityNumber] = useState(null);
  const [abn, setAbn] = useState(null);
  const [businessName, setBusinessName] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [taxResidentCountryText, setTaxResidentCountryText] = useState("US");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [accountType, setAccountType] = useState(null);
  const [currentDocument, setcurrentDocument] = useState({});
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const [nameFromBirth, setNameFromBirth] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);
  const [filter, setFilter] = useState("");
  const [status, setStatus] = useState("resubmit");
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [taxId, setTaxId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(0);
  const [showRecords, setShowRecords] = useState(10);
  const [totalCount, settotalCount] = useState(0);
  const [ownership, setOwnership] = useState(null);
  const [image, setImage] = useState(null);
  const [fullscreen, setFullscreen] = useState(false);
  const [photoId, setphotoId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [middleName, setMiddleName] = useState(null);
  const [countryCode, setCountryCode] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [countryCodeFirst, setCountryCodeFirst] = useState(null);
  const [stateIdFirst, setStateIdFirst] = useState(null);
  const [countryCodeSecond, setCountryCodeSecond] = useState(null);
  const [stateIdSecond, setStateIdSecond] = useState(null);
  const [businessNature, setBusinessNature] = useState(null);
  const [profilePic, setProfilePic] = useState(null);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [fileAttorney, setFileAttorney] = useState(null);
  const [filePurpose, setFilePurpose] = useState(null);
  const [thirdPartySign, setThirdPartySign] = useState(null);
  const [photoIdText, setPhotoIdText] = useState(null);
  const [isOpenAction, setIsOpenAction] = useState(false);
  const statusTextMap = {
    "to-review": "To Review",
    "in-progress": "In Progress",
    resubmit: "Sent For Resubmit",
    approval: "Approval",
  };
  const [businessActivity, setBusinessActivity] = useState(null);
  const [otherActivity, setOtherActivity] = useState("");
  const [jointAccountMembers, setJointAccountMembers] = useState([]);
  const [jointAccountActualMembers, setJointAccountActualMembers] = useState(
    [],
  );
  const [signatory, setSignatory] = useState("yes");
  const [businessAddress, setBusinessAddress] = useState(null);
  const [transactionNature, setTransactionNature] = useState(null);

  const [photoIdFirstText, setphotoIdFirstText] = useState("");
  const [photoIdFirst, setphotoIdFirst] = useState(null);
  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [dob, setDob] = useState(null);
  const [formattedDOB, setFormattedDOB] = useState("");
  const [businessActivityText, setBusinessActivityText] =
    useState("smaple text");
  const [formerNames, setFormerNames] = useState(null);
  const [redAddress, setRedAddress] = useState(null);
  const [clientNo, setClientNo] = useState(null);
  const [expectedAmount, setExpectedAmount] = useState(null);
  const [fundSource, setFundSource] = useState(null);
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [description, setDescription] = useState(null);
  const [fileProof, setFileProof] = useState(null);
  const [documentNumberSecond, setDocumentNumberSecond] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [lastNameSignup, setLastNameSignup] = useState("");
  const [firstNameSignup, setFirstNameSignup] = useState("");
  const [email, setEmail] = useState("");
  const [statusData, setStatusData] = useState([]);

  const statusColorMap = {
    "to-review":
      "border-2 border-[#F77E27] text-[#F77E27] bg-[#F77E27] bg-opacity-30",
    "in-progress":
      "border-2  border-[#FFC421] text-[#FFC421] bg-[#FFC421] bg-opacity-30",
    resubmit:
      "border-2  border-[#3047EC] text-[#3047EC] bg-[#3047EC] bg-opacity-30",
    approval:
      "border-2  border-[#CC00FF] text-[#CC00FF] bg-[#CC00FF] bg-opacity-30",
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const getAllDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/admin/kyc-review/${customerId}`,
      );

      if (response.status == 200) {
        // Open account status
        setFirstNameSignup(
          response.data.open_account_information.first_name.value,
        );
        setLastNameSignup(
          response.data.open_account_information.last_name.value,
        );
        setEmail(response.data.open_account_information.email_address.value);
        setMobileNumber(
          response.data.open_account_information.country_code.value +
            response.data.open_account_information.mobile_number.value,
        );
        setCustomerType(
          response.data.open_account_information.account_type.value,
        );

        //Personal info
        setProfilePic(response.data.personal_information.profile_picture_file);
        setFirstName(response.data.personal_information.first_name);
        setAccountType(response.data.personal_information.account_type);
        setApplicantCountry(
          response.data.personal_information.applicant_country,
        );
        setSocialSecurityNumber(
          response.data.personal_information.social_security_number,
        );
        setLastName(response.data.personal_information.last_name);
        setMiddleName(response.data.personal_information.middle_name);
        setNameFromBirth(response.data.personal_information.is_birth_name);
        setFullName(response.data.personal_information.first_name);
        setFormerNames(response.data.personal_information.former_names);
        const date = new Date(
          response.data.personal_information.date_of_birth.value,
        );
        const formattedDate = date.toLocaleDateString("en-GB");
        setDob(response.data.personal_information.date_of_birth);
        setFormattedDOB(formattedDate);
        setAdvisor(response.data.personal_information.customer_advisor);
        setRedAddress(response.data.personal_information.address);
        setClientNo(response.data.personal_information.client_id);
        setExpectedAmount(
          response.data.personal_information.expected_investment_amount,
        );
        setInvestmentCurrency(
          response.data.personal_information.default_currency,
        );
        //Prove you
        setImage(response.data.liveness_proof.document);

        // Upload docs
        setFileThirdParty(response.data.proof_documents.contract_files);
        setThirdPartySign(
          response.data.proof_documents.has_prosecution_history,
        );
        setDescription(response.data.proof_documents.prosecution_description);
        setFileProof(response.data.proof_documents.prosecution_file);
        if (
          response.data.personal_information.applicant_country.value.id == 14
        ) {
          setphotoId(
            response.data.proof_documents.photographic_documents[0]
              .document_type,
          );
          setPhotoIdText(
            response.data.proof_documents.photographic_documents[0]
              .document_type_name,
          );
          setExpiryDate(
            response.data.proof_documents.photographic_documents[0].expiry_date,
          );
          setCountryCode(
            response.data.proof_documents.photographic_documents[0]
              .country_of_issue,
          );
          setStateId(
            response.data.proof_documents.photographic_documents[0]
              .state_of_issue,
          );
          setDocumentNumber(
            response.data.proof_documents.photographic_documents[0]
              .document_number,
          );
          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.value != 2
          ) {
            setFilePhotographicId(
              response.data.proof_documents.photographic_documents[0].file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.value == 2
          ) {
            setFileDriverLinsenceFront(
              response.data.proof_documents.photographic_documents[0].file,
            );
            setFileDriverLinsenceBack(
              response.data.proof_documents.photographic_documents[0].back_file,
            );
          }
        }

        if (
          response.data.personal_information.applicant_country.value.id != 14
        ) {
          setphotoIdFirst(
            response.data.proof_documents.photographic_documents[0]
              .document_type,
          );
          setphotoIdFirstText(
            response.data.proof_documents.photographic_documents[0]
              .document_type_name,
          );
          setCountryCodeFirst(
            response.data.proof_documents.photographic_documents[0]
              .country_of_issue,
          );
          setStateIdFirst(
            response.data.proof_documents.photographic_documents[0]
              .state_of_issue,
          );
          if (response.data.proof_documents.photographic_documents[1]) {
            setphotoIdSecond(
              response.data.proof_documents.photographic_documents[1]
                .document_type,
            );
            setphotoIdSecondText(
              response.data.proof_documents.photographic_documents[1]
                .document_type_name,
            );
            setDocumentNumberSecond(
              response.data.proof_documents.photographic_documents[1]
                .document_number,
            );
            setExpiryDateSecond(
              response.data.proof_documents.photographic_documents[1]
                .expiry_date,
            );
            setCountryCodeSecond(
              response.data.proof_documents.photographic_documents[1]
                .country_of_issue,
            );
            setStateIdSecond(
              response.data.proof_documents.photographic_documents[1]
                .state_of_issue,
            );
          }

          setDocumentNumber(
            response.data.proof_documents.photographic_documents[0]
              .document_number,
          );
          setExpiryDate(
            response.data.proof_documents.photographic_documents[0].expiry_date,
          );

          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.value != 2
          ) {
            setfilePhotographicIdFirst(
              response.data.proof_documents.photographic_documents[0].file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.value == 2
          ) {
            setFileDriverLinsenceFrontFirst(
              response.data.proof_documents.photographic_documents[0].file,
            );
            setFileDriverLinsenceBackFirst(
              response.data.proof_documents.photographic_documents[0].back_file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[1] &&
            response.data.proof_documents.photographic_documents[1]
              .document_type.value != 2
          ) {
            setfilePhotographicIdSecond(
              response.data.proof_documents.photographic_documents[1].file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[1] &&
            response.data.proof_documents.photographic_documents[1]
              .document_type.value == 2
          ) {
            setFileDriverLinsenceFrontSecond(
              response.data.proof_documents.photographic_documents[1].file,
            );
            setFileDriverLinsenceBackSecond(
              response.data.proof_documents.photographic_documents[1].back_file,
            );
          }
        }
        setNonPhotoId(response.data.proof_documents.non_photogenic_id_type);
        setNonPhotoIdText(
          response.data.proof_documents.non_photogenic_id_type_name,
        );
        setfileNonPhotographicId(
          response.data.proof_documents.non_photogenic_file,
        );
        setPersonalDataId(response.data.proof_documents.personal_details_type);
        setPersonalDataIdText(
          response.data.proof_documents.personal_details_type_name,
        );
        if (response.data.proof_documents.cv_file) {
          setFileCV(response.data.proof_documents.cv_file);
        }
        setWebLink(response.data.proof_documents.website_link);
        setIsDataAvailable(true);
      }
    } catch (err) {
      setIsDataAvailable(false);
      showToast(err.message, "error");
    } finally {
    }
  };
  const getStatus = async () => {
    try {
      setLoading(true);
      const response = await GetAPIcalls(
        `/v1/onboarding/admin/kyc-review/${customerId}/sections`,
      );

      if (response.status == 200) {
        setStatusData(response.data);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, "error");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  const updateApplication = async (action) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      action == "approve"
        ? `${BASE_URL}/v1/onboarding/admin/kyc-review/approve-application`
        : `${BASE_URL}/v1/onboarding/admin/kyc-review/reject-application`;
    const bodyData = {
      user_id: customerId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleUpdateApplication = useCallback(
    debounce(async (e, action) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateApplication(action);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: "success",
          };

          navigate("/customer-list");
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpenAction(false);
      }
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target),
      );
      if (isOutside) {
        setDropdownOpen(null); // Close dropdown if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleDropdownToggleStatus = () => {
    setDropdownOpen((prev) => !prev);
  };
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    setShowPopup(true);
  };
  const kycheaders = [
    "",
    "Full Name",
    "Date Of Birth",
    "Email Address",
    "Mobile Number",
    "Account Type",
  ];
  const memberHeaders = ["", "First name", "Last name", "Email Address"];
  const secondheadersWithAddress = [
    "",
    "First Name",
    "Last Name",
    "Date Of Birth",
    "Email Address",
    "Mobile Number",
    "Residential Address",
    "Account Type",
  ];
  const togglePopup = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (customerId || updateFieldStatus) {
      getStatus();
      getAllDetails();
    }
  }, [customerId, updateFieldStatus]);
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] p-4 bg-white rounded-lg shadow-lg  relative">
      {loadingUpdate && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {loading ? (
        <div className="space-y-6">
          {/* Content Shimmer */}
          {[...Array(5)].map((_, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gray-300 animate-shimmer"></div>
              <div className="h-4 w-full max-w-3xl bg-gray-300 rounded animate-shimmer"></div>
            </div>
          ))}

          {/* Buttons Shimmer */}
          <div className="flex flex-wrap gap-2 mt-4">
            <div className="h-10 w-48 bg-gray-300 rounded-xl animate-shimmer"></div>
            <div className="h-10 w-56 bg-gray-300 rounded-xl animate-shimmer"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="flex flex-wrap justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img src="/note-2.svg" alt="Company Logo" className="mr-3" />
              <span className="font-medium lg:text-lg text-sm">Review KYC</span>
            </div>
            {/* <div className="flex gap-2 mt-4 md:mt-0">
              <button className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl">
                <img src="/send-message.svg" alt="Add Icon" className="mr-2" />
                <span className="lg:inline hidden pr-2">
                  Request Review Access
                </span>
              </button>
              <button className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl">
                <img src="/send-message.svg" alt="Add Icon" className="mr-2" />
                <span className="lg:inline hidden pr-2">
                  Check Matching Details
                </span>
                <span className="bg-[#FF5050] text-xs flex items-center justify-center text-white w-5 h-5 rounded-full ml-2">
                  2
                </span>
              </button>
            </div> */}
          </div>

          <div>
            <div className="flex flex-wrap justify-between items-center mb-4">
              <div className="flex items-center w-full md:w-auto mb-4 md:mb-0">
                <img
                  src="/avatar.svg"
                  alt="Profile"
                  className="h-10 w-10 rounded-full mr-2"
                />
                <div className="flex flex-col md:flex-row md:items-center w-full md:w-auto">
                  <h1 className="text-md font-medium mr-2">
                    {firstNameSignup} {lastNameSignup}
                  </h1>
                  <div className="relative w-full md:w-auto">
                    <div
                      ref={(el) => (buttonRefs.current[`status`] = el)}
                      className="relative w-full md:w-auto"
                    >
                      <button
                        onClick={() => handleDropdownToggleStatus()}
                        className={`w-full md:w-auto font-semibold h-8 rounded-xl text-xs px-2 py-2 flex justify-between items-center focus:outline-none transition-colors duration-200 ${
                          statusColorMap[status] ||
                          "border border-gray-300 text-gray-700 bg-white"
                        }`}
                      >
                        <span className="truncate mr-2">
                          {statusTextMap[status] || "Select Status"}
                        </span>
                        <img
                          src={
                            dropdownOpen
                              ? "/dropdown-up.svg"
                              : "/dropdown-down.svg"
                          }
                          alt="Dropdown Icon"
                          className={`h-5 w-5 flex-shrink-0 ml-auto object-scale-down object-center`}
                        />
                      </button>

                      {/* Dropdown menu */}
                      {dropdownOpen && (
                        <div className="font-semibold absolute mt-1 w-40  bg-white border border-gray-200 rounded-xl shadow-lg z-50">
                          {Object.entries(statusTextMap).map(([key, label]) => (
                            <div
                              key={key}
                              onClick={() => {
                                setStatus(key);
                                setDropdownOpen(false);
                              }}
                              className={`mx-2 px-2 py-1 text-[10px] cursor-pointer rounded-xl my-1 ${
                                statusColorMap[key] ||
                                "border border-gray-300 text-gray-700 bg-white"
                              } hover:opacity-90 transition`}
                            >
                              {label}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex space-x-2 w-full md:w-auto">
                <button
                  onClick={() => {
                    setIsActivityLogOpen(true);
                  }}
                  className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl w-full md:w-auto"
                >
                  <img
                    src="/backward-10-seconds.svg"
                    alt="Add Icon"
                    className="mr-2"
                  />
                  <span className="inline pr-2">Activity Log</span>
                </button>
              </div>
            </div>
            {isActivityLogOpen && (
              <ActivityLog
                onClose={() => setIsActivityLogOpen(false)}
                customerId={customerId}
              />
            )}
            <div className="flex mt-2 items-center  border-colour-custom space-x-2  pt-2 px-4">
              <h1 className="text-md font-medium mb-2 text-center">
                Individual Application Check List
              </h1>
            </div>{" "}
            <SectionStatusGrid sections={statusData} />
          </div>
          {isDataAvailable && (
            <>
              {/* Open Account Information */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-md">
                  <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/profile-circle-black.svg"
                        alt="User Avatar"
                        className="h-6 w-6 mb-2"
                      />
                      <h1 className="text-md font-medium mb-2">
                        {" "}
                        Open Account Information
                      </h1>
                    </div>
                  </div>
                  {/* Will add popup here */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {/* Column 1 */}
                    <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4">
                      <label className="text-sm text-[#A6A6A6]">
                        First Name
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {firstNameSignup}
                      </div>

                      <label className="mt-2 text-sm text-[#A6A6A6]">
                        Last Name
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {lastNameSignup}
                      </div>
                    </div>

                    {/* Column 2 */}
                    <div className="flex flex-col lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <label className="text-sm text-[#A6A6A6]">Email</label>
                      <div className="text-sm break-all whitespace-normal max-w-full">
                        {email}
                      </div>

                      <label className="mt-2 text-sm text-[#A6A6A6]">
                        Mobile
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {mobileNumber}
                      </div>
                    </div>

                    {/* Column 3 */}
                    <div className="flex flex-col lg:pt-4 pt-0 px-4">
                      <label className="text-sm text-[#A6A6A6]">
                        Customer Type
                      </label>
                      <div className="text-sm break-words max-w-full">
                        {customerType}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {showPopup && currentField && (
                <ReviewPopup
                  isOpen={showPopup}
                  currentField={currentField}
                  currentFieldName={currentFieldName}
                  currentFieldValue={currentFieldValue}
                  currentFieldType={currentFieldType}
                  onClose={() => setShowPopup(false)}
                />
              )}
              {/* End  */}
              {/* Personal Information */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-md">
                  <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/profile-circle-black.svg"
                        alt="User Avatar"
                        className="h-6 w-6 mb-2"
                      />
                      <h1 className="text-md font-medium mb-2">
                        {" "}
                        Personal Information
                      </h1>
                    </div>
                    {/* <img
                  onClick={togglePopup}
                  src="/edit-details.svg"
                  alt="Edit Icon"
                  className="w-4 h-4 cursor-pointer"
                /> */}
                  </div>
                  {/* Will add popup here */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4 ">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Profile Picture
                        </label>
                        <StatusButton
                          status={profilePic.status}
                          count={profilePic.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              profilePic,
                              "Profile Picture",
                              profilePic.value.presigned_url,
                              "",
                            )
                          }
                        />
                      </div>
                      <img
                        src={profilePic.value.presigned_url}
                        alt={`${firstName.value}`}
                        className="w-16 h-16 rounded-full object-cover"
                      />
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Advisor Details
                        </label>
                      </div>
                      {advisor.value && (
                        <div className="mt-0 text-sm">
                          {advisor.value.reference_number} (
                          {advisor.value.first_name} {advisor.value.last_name})
                        </div>
                      )}
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Type Of Customer
                        </label>
                      </div>
                      <div className="mt-0 text-sm">
                        {accountType ? accountType.value.name : ""}
                      </div>
                      {applicantCountry.value.id == 233 && (
                        <>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Social Security Number
                            </label>
                            <StatusButton
                              status={socialSecurityNumber.status}
                              count={socialSecurityNumber.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  socialSecurityNumber,
                                  "Social Security Number",
                                  socialSecurityNumber.value,
                                  "",
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {socialSecurityNumber.value}
                          </div>
                        </>
                      )}
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Is this name from birth?
                        </label>
                      </div>
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="birthName"
                            value={true}
                            checked={nameFromBirth.value == true}
                            disabled={true}
                            className="w-4 h-4 text-[#46DA55] border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="birthName"
                            value={false}
                            disabled={true}
                            checked={nameFromBirth.value == false}
                            className="w-4 h-4  border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          First Name
                        </label>
                        <StatusButton
                          status={fullName.status}
                          count={fullName.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              fullName,
                              "First Name",
                              fullName.value,
                              "",
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">{fullName.value}</div>
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Last Name
                        </label>
                        <StatusButton
                          status={lastName.status}
                          count={lastName.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              lastName,
                              "Last Name",
                              lastName.value,
                              "",
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">{lastName.value}</div>

                      {middleName && middleName.value && (
                        <>
                          {" "}
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Middle Name
                            </label>
                            <StatusButton
                              status={middleName.status}
                              count={middleName.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  middleName,
                                  "Middle Name",
                                  middleName.value,
                                  "",
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">{middleName.value}</div>
                        </>
                      )}
                      {formerNames?.value?.length > 0 && (
                        <>
                          <div className="flex mt-2  items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Customer's Former Name(s)
                            </label>
                            <StatusButton
                              status={formerNames.status}
                              count={formerNames.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  formerNames,
                                  "Customer's Former Name(s)",
                                  formerNames.value,
                                  "",
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {formerNames.value}
                          </div>
                        </>
                      )}
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Date of Birth
                        </label>
                        <StatusButton
                          status={dob.status}
                          count={dob.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              dob,
                              "Date of Birth",
                              formattedDOB,
                              "",
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">{formattedDOB}</div>
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Applicant's Country
                        </label>
                        <StatusButton
                          status={applicantCountry.status}
                          count={applicantCountry.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              applicantCountry,
                              "Applicant's Country",
                              applicantCountry.value.name,
                              "",
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">
                        {applicantCountry.value.name}
                      </div>
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Residential Address
                        </label>
                        <StatusButton
                          status={redAddress.status}
                          count={redAddress.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              redAddress,
                              "Residential Address",
                              redAddress.value.google_address,
                              "",
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">
                        {redAddress.value.google_address}
                      </div>
                    </div>
                    <div className="flex lg:pt-4 pt-0 flex-col px-4">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Client No
                        </label>
                      </div>
                      <div className="mt-0 text-sm">{clientNo?.value}</div>
                      {expectedAmount?.value && (
                        <>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Expected Investment Amount
                            </label>
                            <StatusButton
                              status={expectedAmount.status}
                              count={expectedAmount.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  expectedAmount,
                                  "Expected Investment Amount",
                                  expectedAmount.value,
                                  "",
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {expectedAmount.value}
                          </div>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Default Investment Currency
                            </label>
                            <StatusButton
                              status={investmentCurrency.status}
                              count={investmentCurrency.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  investmentCurrency,
                                  "Default Investment Currency",
                                  investmentCurrency?.value?.name,
                                  "",
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {investmentCurrency?.value?.name}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  {/* End  */}
                </div>
              </div>
              {/* End  */}
              {/* Image section */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-md">
                  <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/camera.svg"
                        alt="User Avatar"
                        className="h-6 w-6 mb-2"
                      />
                      <h1 className="text-md font-medium mb-2">
                        {" "}
                        Prove Its You
                      </h1>
                    </div>
                  </div>
                  <div className="mt-3 px-4 flex flex-col md:flex-row items-center md:items-start gap-4">
                    {/* Image Upload Section */}
                    <div>
                      <span className="text-sm text-[#A6A6A6]">
                        Photo Upload
                      </span>

                      <div className="mt-2 relative w-full max-w-[240px] h-40  rounded-md overflow-hidden">
                        {/* Uploaded Image */}
                        <img
                          src={image.value.presigned_url}
                          alt="Uploaded"
                          className="w-full h-full object-cover"
                        />

                        {/* Fullscreen Button */}
                        <button
                          onClick={() => setFullscreen(true)}
                          className="absolute top-2 right-2 "
                        >
                          <img
                            src="/show-full.svg"
                            alt="Full Screen"
                            className="w-5 h-5 text-white"
                          />
                        </button>
                      </div>
                    </div>
                    <StatusButton
                      status={image.status}
                      count={image.comments?.length}
                      openSection={() =>
                        handleStatusClick(
                          image,
                          "Photo Upload",
                          image.value.presigned_url,
                          "",
                        )
                      }
                    />
                  </div>
                </div>
              </div>
              {fullscreen && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4 py-6"
                  onClick={() => setFullscreen(false)}
                >
                  <img
                    src={image.value.presigned_url}
                    alt="Fullscreen"
                    className="max-w-full max-h-full object-contain rounded-md shadow-lg"
                  />
                </div>
              )}
              {/* End */}
              {/* Upload Proof Documents */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-md">
                  <div className="flex flex-wrap md:flex-nowrap items-center justify-between border-colour-custom pt-2 px-4 gap-4">
                    {/* Left Section (Title + Icon) */}
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/note-2.svg"
                        alt="User Avatar"
                        className="h-6 w-6"
                      />
                      <h1 className="text-md font-medium">
                        Upload Proof Documents
                      </h1>
                    </div>

                    {/* Right Section (Button + Edit Icon) */}
                    <div className="flex items-center gap-3">
                      {/* Request More Documents Button */}
                      {/* <button className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-2 rounded-xl">
                        <img
                          src="/request-doc.svg"
                          alt="Add Icon"
                          className="mr-2"
                        />
                        <span className="hidden lg:inline pr-2">
                          Request More Documents
                        </span>
                      </button> */}

                      {/* Edit Icon */}
                      {/* <img
                    onClick={togglePopup}
                    src="/edit-details.svg"
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  /> */}
                    </div>
                  </div>

                  {/* Will add popup here */}
                  {fileThirdParty && fileThirdParty.value && (
                    <div className="grid grid-cols-1 pb-4 mx-4 border-b sm:grid-cols-2 md:grid-cols-3 gap-4">
                      <div className="flex flex-col   md:pl-4 md:pr-0 pt-4 ">
                        <FileUploadDisplay
                          label="Contracts with third parties to verify the intended
                      transaction"
                          fileData={fileThirdParty}
                          onFileClick={handleFileClick}
                        />
                      </div>
                      <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 md:pl-4 pr-2">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="whitespace-normal break-words text-sm text-[#A6A6A6] w-40 md:w-full flex items-center"
                          >
                            Details of any current or recent prosecutions and
                            inquiries related to Money Laundering, terrorist
                            links, tax offences and corruption in respect of the
                            Individual
                          </label>
                          <StatusButton
                            status={thirdPartySign.status}
                            count={thirdPartySign.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                thirdPartySign,
                                "Details of any current or recent prosecutions and inquiries related to Money Laundering, terrorist links, tax offences and corruption in respect of the Individual",
                                thirdPartySign.value,
                                "",
                              )
                            }
                          />
                        </div>
                        <div className="flex items-center gap-4">
                          <label className="flex items-center text-sm text-black">
                            <input
                              type="radio"
                              name="thirdPartySign"
                              value="yes"
                              checked={thirdPartySign.value === true}
                              className="w-4 h-4 text-[#46DA55] border-gray-300 focus:ring-[#46DA55]"
                            />
                            <span className="ml-2">Yes</span>
                          </label>

                          <label className="flex items-center text-sm text-black">
                            <input
                              type="radio"
                              name="thirdPartySign"
                              value="no"
                              checked={thirdPartySign.value === false}
                              className="w-4 h-4  border-gray-300 focus:ring-[#46DA55]"
                            />
                            <span className="ml-2">No</span>
                          </label>
                        </div>{" "}
                        {thirdPartySign.value === true && (
                          <>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Description
                              </label>
                              <StatusButton
                                status={description.status}
                                count={description.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    description,
                                    "Description",
                                    description.value,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <div className="mt-0 text-sm">
                              {description.value}
                            </div>
                          </>
                        )}
                      </div>
                      <div className="flex lg:pt-4 pt-0 md:pl-4 pr-2 flex-col">
                        {thirdPartySign.value === true && (
                          <>
                            <FileUploadDisplay
                              label="Upload Proof"
                              fileData={fileProof}
                              onFileClick={handleFileClick}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  {/* Extra details */}
                  <div className="grid grid-cols-1 pb-4 pt-2 mx-4 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="flex flex-col tex-xs ">
                      {applicantCountry.value.id == 14 && (
                        <>
                          <div className="flex items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                            >
                              Photographic ID{" "}
                            </label>
                          </div>
                          <div className="mt-0 text-sm  md:pr-0">
                            {photoIdText.value}
                          </div>
                          {(photoId.value == 1 || photoId.value == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoId.value == 1
                                    ? "Upload Certified Copy of Passport"
                                    : "Upload Photo ID issued under a State or Territory law"
                                }
                                fileData={filePhotographicId}
                                onFileClick={handleFileClick}
                              />
                              {photoId.value == 1 && (
                                <>
                                  <div className="mt-2 flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Passport Number{" "}
                                    </label>
                                    <StatusButton
                                      status={documentNumber.status}
                                      count={documentNumber.comments?.length}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumber,
                                          "Passport Number",
                                          documentNumber.value,
                                          "",
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumber.value}</span>
                                </>
                              )}
                              {photoId.value == 3 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Document Number
                                    </label>
                                    <StatusButton
                                      status={documentNumber.status}
                                      count={documentNumber.comments?.length}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumber,
                                          "Document Number",
                                          documentNumber.value,
                                          "",
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumber.value}</span>
                                </>
                              )}
                            </>
                          )}
                          {photoId.value == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Certified Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFront}
                                onFileClick={handleFileClick}
                              />
                              <FileUploadDisplay
                                label="Upload Certified Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBack}
                                onFileClick={handleFileClick}
                              />
                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Driver's License Number
                                </label>
                                <StatusButton
                                  status={documentNumber.status}
                                  count={documentNumber.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      documentNumber,
                                      "Driver's License Number",
                                      documentNumber.value,
                                      "",
                                    )
                                  }
                                />
                              </div>
                              <span>{documentNumber.value}</span>
                            </>
                          )}
                          <div className="flex items-center justify-between  md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Expiry Date
                            </label>
                            <StatusButton
                              status={expiryDate.status}
                              count={expiryDate.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  expiryDate,
                                  " Expiry Date",
                                  expiryDate
                                    ? new Date(
                                        expiryDate.value,
                                      ).toLocaleDateString("en-GB")
                                    : "",
                                  "",
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {expiryDate
                              ? new Date(expiryDate.value).toLocaleDateString(
                                  "en-GB",
                                )
                              : ""}
                          </div>
                          <div className="flex mt-2 items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Country where issued
                            </label>
                            <StatusButton
                              status={countryCode.status}
                              count={countryCode.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  countryCode,
                                  " Country where issued",
                                  countryCode.value.name,
                                  "",
                                )
                              }
                            />
                          </div>
                          <span>{countryCode?.value?.name}</span>

                          {countryCode?.value?.id == 14 && (
                            <>
                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  State or Territory in Australia
                                </label>
                                <StatusButton
                                  status={stateId.status}
                                  count={stateId.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      stateId,
                                      "State or Territory in Australia",
                                      stateId.value.name,
                                      "",
                                    )
                                  }
                                />
                              </div>
                              <span>{stateId.value.name}</span>
                            </>
                          )}
                        </>
                      )}
                      {applicantCountry.value.id != 14 && (
                        <>
                          <div className="flex items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                            >
                              Select First Photographic ID
                            </label>
                          </div>
                          <div className="mt-0 text-sm  md:pr-0">
                            {photoIdFirstText.value}
                          </div>
                          {(photoIdFirst.value == 1 ||
                            photoIdFirst.value == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoIdFirst.value == 1
                                    ? "Upload Certified Copy of Passport"
                                    : "Upload Photo ID issued under a State or Territory law"
                                }
                                fileData={filePhotographicIdFirst}
                                onFileClick={handleFileClick}
                              />
                              {photoIdFirst.value == 1 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Passport Number
                                    </label>
                                    <StatusButton
                                      status={documentNumber.status}
                                      count={documentNumber.comments?.length}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumber,
                                          "Passport Number",
                                          documentNumber.value,
                                          "",
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumber.value}</span>
                                </>
                              )}
                              {photoIdFirst.value == 3 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Document Number
                                    </label>
                                    <StatusButton
                                      status={documentNumber.status}
                                      count={documentNumber.comments?.length}
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumber,
                                          "Document Number",
                                          documentNumber.value,
                                          "",
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumber.value}</span>
                                </>
                              )}
                            </>
                          )}
                          {photoIdFirst.value == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Certified Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFrontFirst}
                                onFileClick={handleFileClick}
                              />
                              <FileUploadDisplay
                                label="Upload Certified Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBackFirst}
                                onFileClick={handleFileClick}
                              />

                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  Driver's License Number
                                </label>
                                <StatusButton
                                  status={documentNumber.status}
                                  count={documentNumber.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      documentNumber,
                                      "Driver's License Number",
                                      documentNumber.value,
                                      "",
                                    )
                                  }
                                />
                              </div>
                              <span>{documentNumber.value}</span>
                            </>
                          )}
                          <div className="flex items-center justify-between  md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Expiry Date
                            </label>
                            <StatusButton
                              status={expiryDate.status}
                              count={expiryDate.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  expiryDate,
                                  "Expiry Date",
                                  expiryDate
                                    ? new Date(
                                        expiryDate.value,
                                      ).toLocaleDateString("en-GB")
                                    : "",
                                  "",
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {expiryDate
                              ? new Date(expiryDate.value).toLocaleDateString(
                                  "en-GB",
                                )
                              : ""}
                          </div>
                          <div className="flex mt-2 items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Country where issued
                            </label>
                            <StatusButton
                              status={countryCodeFirst.status}
                              count={countryCodeFirst.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  countryCodeFirst,
                                  " Country where issued",
                                  countryCodeFirst.value.name,
                                  "",
                                )
                              }
                            />
                          </div>
                          <span>{countryCodeFirst.value.name}</span>

                          {countryCodeFirst.value.id == 14 && (
                            <>
                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  State or Territory in Australia
                                </label>
                                <StatusButton
                                  status={stateIdFirst.status}
                                  count={stateIdFirst.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      stateIdFirst,
                                      "State or Territory in Australia",
                                      stateIdFirst.value.name,
                                      "",
                                    )
                                  }
                                />
                              </div>
                              <span>{stateIdFirst.value.name}</span>
                            </>
                          )}
                          <div className="flex items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                            >
                              Select Second Photographic ID
                            </label>
                          </div>
                          <div className="mt-0 text-sm  md:pr-0">
                            {photoIdSecondText.value}
                          </div>
                          {(photoIdSecond.value == 1 ||
                            photoIdSecond.value == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoIdSecond.value == 1
                                    ? "Upload Certified Copy of Passport"
                                    : "Upload Photo ID issued under a State or Territory law"
                                }
                                fileData={filePhotographicIdSecond}
                                onFileClick={handleFileClick}
                              />
                              {photoIdSecond.value == 1 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Passport Number
                                    </label>
                                    <StatusButton
                                      status={documentNumberSecond.status}
                                      count={
                                        documentNumberSecond.comments?.length
                                      }
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumberSecond,
                                          "Passport Number",
                                          documentNumberSecond.value,
                                          "",
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumberSecond.value}</span>
                                </>
                              )}
                              {photoIdSecond.value == 3 && (
                                <>
                                  <div className="flex items-center justify-between md:pr-0">
                                    <label
                                      htmlFor="investmentType"
                                      className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                    >
                                      Document Number
                                    </label>
                                    <StatusButton
                                      status={documentNumberSecond.status}
                                      count={
                                        documentNumberSecond.comments?.length
                                      }
                                      openSection={() =>
                                        handleStatusClick(
                                          documentNumberSecond,
                                          "Document Number",
                                          documentNumberSecond.value,
                                          "",
                                        )
                                      }
                                    />
                                  </div>
                                  <span>{documentNumberSecond.value}</span>
                                </>
                              )}
                            </>
                          )}
                          {photoIdSecond.value == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Certified Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFrontSecond}
                                onFileClick={handleFileClick}
                              />
                              <FileUploadDisplay
                                label="Upload Certified Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBackSecond}
                                onFileClick={handleFileClick}
                              />
                              <div className="flex items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center"
                                >
                                  Driver's License Number
                                </label>
                                <StatusButton
                                  status={documentNumberSecond.status}
                                  count={documentNumberSecond.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      documentNumberSecond,
                                      "Driver's License Number",
                                      documentNumberSecond.value,
                                      "",
                                    )
                                  }
                                />
                              </div>
                              <span>{documentNumberSecond.value}</span>
                            </>
                          )}
                          <div className="flex items-center justify-between  md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Expiry Date
                            </label>
                            <StatusButton
                              status={expiryDateSecond.status}
                              count={expiryDateSecond.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  expiryDateSecond,
                                  "Expiry Date",
                                  expiryDateSecond
                                    ? new Date(
                                        expiryDateSecond.value,
                                      ).toLocaleDateString("en-GB")
                                    : "",
                                  "",
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {expiryDateSecond
                              ? new Date(
                                  expiryDateSecond.value,
                                ).toLocaleDateString("en-GB")
                              : ""}
                          </div>
                          <div className="flex mt-2 items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Country where issued
                            </label>
                            <StatusButton
                              status={countryCodeSecond.status}
                              count={countryCodeSecond.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  countryCodeSecond,
                                  " Country where issued",
                                  countryCodeSecond.value.name,
                                  "",
                                )
                              }
                            />
                          </div>
                          <span>{countryCodeSecond.value.name}</span>

                          {countryCodeSecond.value.id == 14 && (
                            <>
                              <div className="flex mt-2 items-center justify-between md:pr-0">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  State or Territory in Australia
                                </label>
                                <StatusButton
                                  status={stateIdSecond.status}
                                  count={stateIdSecond.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      stateId,
                                      "State or Territory in Australia",
                                      stateIdSecond.value.name,
                                      "",
                                    )
                                  }
                                />
                              </div>
                              <span>{stateIdSecond.value.name}</span>
                            </>
                          )}
                        </>
                      )}
                    </div>
                    <div className="flex px-2 flex-col lg:pt-2 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 ">
                      <div className="flex items-center justify-between ">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] w-40 md:w-full flex items-center"
                        >
                          Non Photographic ID
                        </label>
                      </div>
                      <span>{nonphotoIdText.value}</span>
                      <FileUploadDisplay
                        label="Uploaded Document"
                        fileData={fileNonPhotographicId}
                        onFileClick={handleFileClick}
                      />
                    </div>
                    <div className="flex lg:pt-2 pt-0 flex-col">
                      <div className="flex items-center justify-between lg:pl-4 pr-2">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] w-40 md:w-full flex items-center"
                        >
                          Personal Details{" "}
                        </label>
                      </div>
                      <div className="mt-0 text-sm lg:pl-4 md:pr-0 pb-2">
                        {personalDataIdText.value}
                      </div>
                      {personalDataId.value == 1 && (
                        <>
                          <FileUploadDisplay
                            label="Uploaded CV"
                            fileData={fileCV}
                            onFileClick={handleFileClick}
                          />
                        </>
                      )}
                      {personalDataId.value == 2 && (
                        <>
                          <div className="flex mt-2 items-center  lg:pl-4 pr-2 justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Website Link
                            </label>
                            <StatusButton
                              status={webLink.status}
                              count={webLink.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  webLink,
                                  "Website Link",
                                  webLink.value,
                                  "",
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm lg:pl-4 md:pr-0 pb-2">
                            {webLink.value}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* End  */}
              <div className="flex items-center mt-6 p-4 bg-[#005A9C]">
                {/* Right Section: Download Button */}
                <div className="flex items-center justify-end w-full">
                  <div className="relative inline-block mr-4">
                    {/* Button */}
                    <div
                      className="flex text-sm justify-between items-center py-2 px-2 border border-white  w-40 rounded-full cursor-pointer"
                      onClick={() => {
                        const historyStack = location.state?.historyStack || [];
                        const lastRoute =
                          historyStack.length > 0
                            ? historyStack[historyStack.length - 1]
                            : "/";

                        navigate(lastRoute, {
                          state: {
                            fromViewHistory: true,
                            historyStack: historyStack.slice(
                              0,
                              historyStack.length - 1,
                            ),
                          },
                        });
                      }}
                    >
                      <span className="text-right pl-4 text-white">Back</span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument.file_name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};

export default ReviewKycJointAccount;
